import React, {Component, Fragment} from "react";
import {Button, Col, Input, Label, Row, TabContent, TabPane} from "reactstrap";
import {toast} from "react-toastify";
import {getData, postData} from "../../../api/doLogin";
import {prependIf, trimJoin} from "../../../util/stringhelpers";
import {formatDate, makeDate} from "../../../util/datehelpers";
import LMSFolderSelection from "../../Leads/modals/LMSFolderSelection";
import {EventClient} from "../../../util/eventClient";
import {hasPermission} from "../../../api/permissionHelper";
import {RequiredPermissions} from "../../../api/permissions";

export class BriefcaseAddToLMS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "main",
      searchData: {},
      newLeadData: {},
      results: []
    }
  }

  search(page = 1) {
    if (Object.keys(this.state.searchData).length === 0) {
      toast.error("Fill out search field")
      return;
    }
    const searchingData = Object.values(this.state.searchData).map((val) => val).join("");
    if (searchingData.length === 0) {
      toast.error("Fill out search field")
      return;
    }
    var self = this;
    const searchData = {
      q: this.state.searchData.query || "",
      page: page,
      limit: 50
    };
    // if (this.state.formData['all']) {
    //   searchData['all'] = true;
    // }
    self.setState({activeTab: "loading"});
    getData("lms/leads", searchData)
      .then((data) => {
        if (data.status === "Success") {
          // console.log(data.data);
          self.setState({
            results: data.data.leads,
            page: Number(data.data.page),
            totalResults: Number(data.data.results),
            limit: Number(data.data.limit),
            activeTab: "search2results"
          });
        }
      })
      .catch(error => {
        self.setState({activeTab: "search2"});
        toast.error(error.message);
        console.error(error);
      });
  }

  selectAddLMS(id) {
    let self = this;
    if (confirm('This will transfer the file and comments to the Marketing Manager. Any unsaved comments and status\' will be lost. Continue?')) {
      self.setState({activeTab: "loading"});
      let data = {
        ...this.props.fileData,
      };
      postData(`lms/leads/frombc/${id}`, data)
        .then((data) => {
          if (data.status === "Success") {
            self.setState({
              searchData: {},
              results: [],
              newLeadData: {},
              activeTab: "main"
            }, () => {
              self.props.onAddSuccess && self.props.onAddSuccess();
            });
          } else {
            self.setState({activeTab: "search2results"});
            toast.error(data.message);
          }
        })
        .catch(error => {
          self.setState({activeTab: "search2results"});
          toast.error(error.message);
          console.error(error);
        });
    }
  }

  addNewLMS() {
    let self = this;
    if (confirm('This will Create a new entry in the LMS with the data you entered. Any unsaved comments and status\' will be lost. Continue?')) {
      self.setState({activeTab: "loading"});
      let data = {
        file: {...this.props.fileData},
        lead: {...this.state.newLeadData}
      };
      postData(`lms/leads/new`, data)
        .then((data) => {
          if (data.status === "Success") {
            self.setState({
              searchData: {},
              results: [],
              newLeadData: {},
              activeTab: "main"
            }, () => {
              self.props.onAddSuccess && self.props.onAddSuccess();
            });
          } else {
            self.setState({activeTab: "addpage4"});
            toast.error(data.message);
          }
        })
        .catch(error => {
          self.setState({activeTab: "addpage4"});
          toast.error(error.message);
          console.error(error);
        });
    }
  }

  mapJSX(data) {
    return data.map((result, index) => <Fragment key={`${index}`}>{result}<br/></Fragment>)
  }

  render() {
    return <div>
      <TabContent activeTab={this.state.activeTab}>

        <TabPane tabId="main">
          <Row>
            <Col xs="12" md={"6"}>
              <div style={{display: "flex", justifyContent: "space-between"}}>
                <Input type={"textarea"}
                       style={{marginRight: 10}}
                       multiple={true}
                       rows={7}
                       onChange={(evt) => {
                         this.props.setFileData({notes: evt.target.value})
                       }}
                       value={this.props.fileData.notes || ""}/>
                <div style={{display: "flex", flexDirection: "column", justifyContent: "space-around"}}>
                  {hasPermission(RequiredPermissions.LMSSave) && !(this.props.fileData.lmsID && this.props.fileData.lmsID > 0) &&(
                    <Button onClick={() => this.setState({activeTab: "search2"})}>Add to LMS</Button>
                  )}

                  <Button onClick={() => (this.setState({activeTab: "main"}), this.props.onClose())}>Close</Button>
                </div>
              </div>
            </Col>
          </Row>
        </TabPane>

        <TabPane tabId={"loading"}>
          <div className="sk-wave">
            <div className="sk-rect sk-rect1"></div>
            &nbsp;
            <div className="sk-rect sk-rect2"></div>
            &nbsp;
            <div className="sk-rect sk-rect3"></div>
            &nbsp;
            <div className="sk-rect sk-rect4"></div>
            &nbsp;
            <div className="sk-rect sk-rect5"></div>
          </div>
        </TabPane>

        <TabPane tabId="search">
          <Row>
            <Col xs="4">
              <Input type={"textarea"}
                     style={{marginRight: 10}}
                     multiple={true}
                     rows={7}
                     onChange={(evt) => {
                       this.props.setFileData({notes: evt.target.value})
                     }}
                     value={this.props.fileData.notes || ""}/>
            </Col>
            <Col xs="2">
              <div style={{display: "flex", flexDirection: "column", justifyContent: "space-around", fontSize: 11}}>
                <div>Search for Existing [Help]</div>
                <div>
                  First Name:
                  <Input style={{padding: 0}}
                         value={this.state.searchData.firstName || ""}
                         onChange={(evt) => this.setState({
                           searchData: {
                             ...this.state.searchData,
                             firstName: evt.target.value
                           }
                         })}
                  />
                </div>
                <div>
                  Last Name:
                  <Input style={{padding: 0}}
                         value={this.state.searchData.lastName || ""}
                         onChange={(evt) => this.setState({
                           searchData: {
                             ...this.state.searchData,
                             lastName: evt.target.value
                           }
                         })}/>
                </div>
                <div>
                  Spouse Name:
                  <Input style={{padding: 0}}
                         value={this.state.searchData.spouseName || ""}
                         onChange={(evt) => this.setState({
                           searchData: {
                             ...this.state.searchData,
                             spouseName: evt.target.value
                           }
                         })}/>
                </div>
              </div>
            </Col>
            <Col xs={2}>
              <div style={{display: "flex", flexDirection: "column", justifyContent: "space-around", fontSize: 11}}>
                <div>&nbsp;</div>
                <div>
                  Cell Phone:
                  <Input style={{padding: 0}}
                         value={this.state.searchData.cellPhone || ""}
                         onChange={(evt) => this.setState({
                           searchData: {
                             ...this.state.searchData,
                             cellPhone: evt.target.value
                           }
                         })}/>
                </div>
                <div>
                  Home Phone:
                  <Input style={{padding: 0}}
                         value={this.state.searchData.homePhone || ""}
                         onChange={(evt) => this.setState({
                           searchData: {
                             ...this.state.searchData,
                             homePhone: evt.target.value
                           }
                         })}/>
                </div>
                <div>
                  Email:
                  <Input style={{padding: 0}}
                         value={this.state.searchData.email || ""}
                         onChange={(evt) => this.setState({
                           searchData: {
                             ...this.state.searchData,
                             email: evt.target.value
                           }
                         })}/>
                </div>
              </div>
            </Col>
            <Col xs={2}>
              <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
                fontSize: 11,
                height: "100%"
              }}>
                <div>&nbsp;</div>
                <Button onClick={() => {
                  if (Object.keys(this.state.searchData).length === 0) {
                    toast.error("Fill out a search field")
                    return;
                  }
                  const searchData = Object.values(this.state.searchData).map((val) => val).join("");
                  if (searchData.length === 0) {
                    toast.error("Fill out a search field")
                    return;
                  }
                  this.setState({activeTab: "loading"});
                }}>Search</Button>
                <Button onClick={() => this.setState({searchData: {}, activeTab: "main"})}>Cancel</Button>
              </div>
            </Col>
          </Row>
        </TabPane>

        <TabPane tabId="search2">
          <Row>
            <Col xs="4">
              <Input type={"textarea"}
                     style={{marginRight: 10}}
                     multiple={true}
                     rows={7}
                     onChange={(evt) => {
                       this.props.setFileData({notes: evt.target.value})
                     }}
                     value={this.props.fileData.notes || ""}/>
            </Col>
            <Col xs="3">
              <div style={{display: "flex", flexDirection: "column", justifyContent: "space-around", fontSize: 11}}>
                <div>Search for Existing Lead</div>
                <Input style={{padding: 0}}
                       value={this.state.searchData.query || ""}
                       onKeyPress={(evt) => {
                         if (evt.key === "Enter") {
                           this.search();
                         }
                       }}
                       onChange={(evt) => this.setState({
                         searchData: {
                           ...this.state.searchData,
                           query: evt.target.value
                         }
                       })}
                />
              </div>
            </Col>
            <Col xs={2}>
              <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
                fontSize: 11,
                height: "100%"
              }}>
                <div>&nbsp;</div>
                <Button onClick={() => {
                  this.search();
                }}>Search</Button>
                <Button onClick={() => this.setState({searchData: {}, activeTab: "main"})}>Cancel</Button>
              </div>
            </Col>
          </Row>
        </TabPane>

        <TabPane tabId="search2results">
          <Row>
            <Col xs="4">
              <Input type={"textarea"}
                     style={{marginRight: 10}}
                     multiple={true}
                     rows={7}
                     onChange={(evt) => {
                       this.props.setFileData({notes: evt.target.value})
                     }}
                     value={this.props.fileData.notes || ""}/>
            </Col>
            <Col xs="6">
              <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                fontSize: 11,
                overflowY: "auto",
                maxHeight: "25vh"
              }}>
                <div>Lead results: {this.state.searchData.query}</div>
                {(this.state.results || []).map((result) => {
                  const buildName = trimJoin([result.fname, result.mname, result.lname]);
                  const firstLine = trimJoin([buildName, result.rank, result.branch, `${result.retired === 1 ? "Retired" : ""}`, `${result.blacklist === 1 ? "    ** BLACKLISTED **" : ""}`], ", ")
                  const address = trimJoin([result.address1, result.address2, result.city, result.state, result.zip], ", ");
                  const maritalLine = result.maritalstatus === "Single" ? "Single" : `Married to ${trimJoin([result.spfname, result.spmname, result.splname])}`
                  const phoneLine = trimJoin([
                    prependIf(result.cellphone, "(C) "),
                    prependIf(result.homephone, "(H) "),
                    prependIf(result.dutyphone, "(W) "),
                  ]);
                  const emailLine = trimJoin([
                    prependIf(result.homeemail, "(H) "),
                    prependIf(result.dutyemail, "(W) "),
                  ]);
                  const leadInfo = trimJoin([
                    prependIf(formatDate(makeDate(result.dated)), "Lead Since: "),
                    prependIf(result.source, "Source: "),
                  ]);
                  // const path = "Path:".concat(result.folderPath);
                  return <div key={`${result.id}`} style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid black",
                    padding: "4px 0"
                  }}>
                    <div>
                      {this.mapJSX(trimJoin([firstLine, address, maritalLine, phoneLine, emailLine, leadInfo], "\n").split("\n"))}
                    </div>
                    <div style={{display: "flex", flexDirection: "column"}}>
                      <Button onClick={() => this.selectAddLMS(result.id)}>Select</Button>
                      <Button onClick={() => EventClient.emit("LMS_ENTRY_EDIT", result.id)}>View Lead</Button>
                    </div>
                  </div>
                })}
                <div align={"center"}>
                  {this.state.results.length > 0 && (
                    <Fragment>
                      <span>Not in the list above?</span>
                      <br/>
                    </Fragment>
                  )}

                  <Button onClick={() => this.setState({results: [], activeTab: "search2"})}>Refine
                    Search</Button>
                  <Button onClick={() => this.setState({results: [], activeTab: "addpage1"})}>Add
                    New Lead</Button>
                  <Button
                    onClick={() => this.setState({searchData: {}, results: [], activeTab: "main"})}>Cancel</Button>
                </div>
              </div>
            </Col>
            <Col xs={2}>
              <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
                fontSize: 11,
                height: "100%"
              }}>
                <div>&nbsp;</div>
                <Button onClick={() => this.setState({results: [], activeTab: "search2"})}>Refine
                  Search</Button>
                <Button onClick={() => this.setState({searchData: {}, results: [], activeTab: "main"})}>Cancel</Button>
              </div>
            </Col>
          </Row>
        </TabPane>

        <TabPane tabId="addpage1">
          <Row>
            <Col xs="4">
              <Input type={"textarea"}
                     style={{marginRight: 10}}
                     multiple={true}
                     rows={7}
                     onChange={(evt) => {
                       this.props.setFileData({notes: evt.target.value})
                     }}
                     value={this.props.fileData.notes || ""}/>
            </Col>
            <Col xs="2">
              <div style={{display: "flex", flexDirection: "column", justifyContent: "space-around", fontSize: 11}}>
                <div>Add LMS Lead - Page 1 / 4</div>
                <div>
                  First Name:
                  <Input style={{padding: 0}}
                         value={this.state.newLeadData.fname || ""}
                         onChange={(evt) => this.setState({
                           newLeadData: {
                             ...this.state.newLeadData,
                             fname: evt.target.value
                           }
                         })}
                  />
                </div>
                <div>
                  Last Name:
                  <Input style={{padding: 0}}
                         value={this.state.newLeadData.lname || ""}
                         onChange={(evt) => this.setState({
                           newLeadData: {
                             ...this.state.newLeadData,
                             lname: evt.target.value
                           }
                         })}/>
                </div>
                {(this.state.newLeadData.maritalstatus || "Single") === "Married" && (
                  <Fragment>
                    <div>
                      Spouse First Name:
                      <Input style={{padding: 0}}
                             value={this.state.newLeadData.spfname || ""}
                             onChange={(evt) => this.setState({
                               newLeadData: {
                                 ...this.state.newLeadData,
                                 spfname: evt.target.value
                               }
                             })}/>
                    </div>
                    <div>
                      Spouse Last Name:
                      <Input style={{padding: 0}}
                             value={this.state.newLeadData.splname || ""}
                             onChange={(evt) => this.setState({
                               newLeadData: {
                                 ...this.state.newLeadData,
                                 splname: evt.target.value
                               }
                             })}/>
                    </div>
                  </Fragment>
                )}
              </div>
            </Col>
            <Col xs={2}>
              <div style={{display: "flex", flexDirection: "column", justifyContent: "space-around", fontSize: 11}}>
                <div>&nbsp;</div>
                <div>
                  <Label check>Married:</Label>
                  <Input style={{padding: 0, marginLeft: 15}}
                         type={"checkbox"}
                         checked={this.state.newLeadData.maritalstatus === "Married" ? true : false}
                         onChange={(evt) => this.setState({
                           newLeadData: {
                             ...this.state.newLeadData,
                             maritalstatus: evt.target.checked ? "Married" : "Single"
                           }
                         })}/>
                </div>
                <div>
                  Cell Phone:
                  <Input style={{padding: 0}}
                         value={this.state.newLeadData.cellphone || ""}
                         onChange={(evt) => this.setState({
                           newLeadData: {
                             ...this.state.newLeadData,
                             cellphone: evt.target.value
                           }
                         })}/>
                </div>
                <div>
                  Home Phone:
                  <Input style={{padding: 0}}
                         value={this.state.newLeadData.homephone || ""}
                         onChange={(evt) => this.setState({
                           newLeadData: {
                             ...this.state.newLeadData,
                             homephone: evt.target.value
                           }
                         })}/>
                </div>
                <div>
                  Email:
                  <Input style={{padding: 0}}
                         value={this.state.newLeadData.homeemail || ""}
                         onChange={(evt) => this.setState({
                           newLeadData: {
                             ...this.state.newLeadData,
                             homeemail: evt.target.value
                           }
                         })}/>
                </div>
              </div>
            </Col>
            <Col xs={2}>
              <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
                fontSize: 11,
                height: "100%"
              }}>
                <div>&nbsp;</div>
                <div>
                  <Button onClick={() => {
                    this.setState({activeTab: "search2results", newLeadData: {}});
                  }}>&lt; &lt; Prev</Button>
                  <Button onClick={() => {
                    this.setState({activeTab: "addpage2"});
                  }}>Next &gt;&gt;</Button>
                </div>
                <Button
                  onClick={() => this.setState({searchData: {}, newLeadData: {}, activeTab: "main"})}>Cancel</Button>
              </div>
            </Col>
          </Row>
        </TabPane>

        <TabPane tabId="addpage2">
          <Row>
            <Col xs="4">
              <Input type={"textarea"}
                     style={{marginRight: 10}}
                     multiple={true}
                     rows={7}
                     onChange={(evt) => {
                       this.props.setFileData({notes: evt.target.value})
                     }}
                     value={this.props.fileData.notes || ""}/>
            </Col>
            <Col xs="2">
              <div style={{display: "flex", flexDirection: "column", justifyContent: "space-around", fontSize: 11}}>
                <div>Add LMS Lead - Page 2 / 4</div>
                <div>
                  Address 1:
                  <Input style={{padding: 0}}
                         value={this.state.newLeadData.address1 || ""}
                         onChange={(evt) => this.setState({
                           newLeadData: {
                             ...this.state.newLeadData,
                             address1: evt.target.value
                           }
                         })}
                  />
                </div>
                <div>
                  Address 2:
                  <Input style={{padding: 0}}
                         value={this.state.newLeadData.address2 || ""}
                         onChange={(evt) => this.setState({
                           newLeadData: {
                             ...this.state.newLeadData,
                             address2: evt.target.value
                           }
                         })}/>
                </div>
                <div>
                  City:
                  <Input style={{padding: 0}}
                         value={this.state.newLeadData.city || ""}
                         onChange={(evt) => this.setState({
                           newLeadData: {
                             ...this.state.newLeadData,
                             city: evt.target.value
                           }
                         })}/>
                </div>
                <div>
                  State:
                  <Input style={{padding: 0}}
                         value={this.state.newLeadData.state || ""}
                         onChange={(evt) => this.setState({
                           newLeadData: {
                             ...this.state.newLeadData,
                             state: evt.target.value
                           }
                         })}/>
                </div>
              </div>
            </Col>
            <Col xs={2}>
              <div style={{display: "flex", flexDirection: "column", justifyContent: "space-around", fontSize: 11}}>
                <div>&nbsp;</div>
                <div>
                  Zip:
                  <Input style={{padding: 0}}
                         value={this.state.newLeadData.zip || ""}
                         onChange={(evt) => this.setState({
                           newLeadData: {
                             ...this.state.newLeadData,
                             zip: evt.target.value
                           }
                         })}/>
                </div>
              </div>
            </Col>
            <Col xs={2}>
              <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
                fontSize: 11,
                height: "100%"
              }}>
                <div>&nbsp;</div>
                <div>
                  <Button onClick={() => {
                    this.setState({activeTab: "addpage1"});
                  }}>&lt; &lt; Prev</Button>
                  <Button onClick={() => {
                    this.setState({activeTab: "addpage3"});
                  }}>Next &gt;&gt;</Button>
                </div>
                <Button
                  onClick={() => this.setState({searchData: {}, newLeadData: {}, activeTab: "main"})}>Cancel</Button>
              </div>
            </Col>
          </Row>
        </TabPane>

        <TabPane tabId="addpage3">
          <Row>
            <Col xs="4">
              <Input type={"textarea"}
                     style={{marginRight: 10}}
                     multiple={true}
                     rows={7}
                     onChange={(evt) => {
                       this.props.setFileData({notes: evt.target.value})
                     }}
                     value={this.props.fileData.notes || ""}/>
            </Col>
            <Col xs="2">
              <div style={{display: "flex", flexDirection: "column", justifyContent: "space-around", fontSize: 11}}>
                <div>Add LMS Lead - Page 3 / 4</div>
                <div>
                  Rank:
                  <Input style={{padding: 0}}
                         value={this.state.newLeadData.rank || ""}
                         onChange={(evt) => this.setState({
                           newLeadData: {
                             ...this.state.newLeadData,
                             rank: evt.target.value
                           }
                         })}
                  />
                </div>
                <div>
                  Duty Phone:
                  <Input style={{padding: 0}}
                         value={this.state.newLeadData.dutyphone || ""}
                         onChange={(evt) => this.setState({
                           newLeadData: {
                             ...this.state.newLeadData,
                             dutyphone: evt.target.value
                           }
                         })}/>
                </div>
                <div>
                  Duty Email:
                  <Input style={{padding: 0}}
                         value={this.state.newLeadData.dutyemail || ""}
                         onChange={(evt) => this.setState({
                           newLeadData: {
                             ...this.state.newLeadData,
                             dutyemail: evt.target.value
                           }
                         })}/>
                </div>
                <div>
                  Duty Status:
                  <Input style={{padding: 0}}
                         value={this.state.newLeadData.dutystatus || ""}
                         onChange={(evt) => this.setState({
                           newLeadData: {
                             ...this.state.newLeadData,
                             dutystatus: evt.target.value
                           }
                         })}/>
                </div>
              </div>
            </Col>
            <Col xs={2}>
              <div style={{display: "flex", flexDirection: "column", justifyContent: "space-around", fontSize: 11}}>
                <div>&nbsp;</div>
                <div>
                  Branch:
                  <Input style={{padding: 0}}
                         value={this.state.newLeadData.branch || ""}
                         onChange={(evt) => this.setState({
                           newLeadData: {
                             ...this.state.newLeadData,
                             branch: evt.target.value
                           }
                         })}/>
                </div>
                <div>
                  Rate (Navy):
                  <Input style={{padding: 0}}
                         value={this.state.newLeadData.rate || ""}
                         onChange={(evt) => this.setState({
                           newLeadData: {
                             ...this.state.newLeadData,
                             rate: evt.target.value
                           }
                         })}/>
                </div>
                <div>
                  Command:
                  <Input style={{padding: 0}}
                         value={this.state.newLeadData.command || ""}
                         onChange={(evt) => this.setState({
                           newLeadData: {
                             ...this.state.newLeadData,
                             command: evt.target.value
                           }
                         })}/>
                </div>
              </div>
            </Col>
            <Col xs={2}>
              <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
                fontSize: 11,
                height: "100%"
              }}>
                <div>&nbsp;</div>
                <div>
                  <Button onClick={() => {
                    this.setState({activeTab: "addpage2"});
                  }}>&lt; &lt; Prev</Button>
                  <Button onClick={() => {
                    this.setState({activeTab: "addpage4"});
                  }}>Next &gt;&gt;</Button>
                </div>
                <Button
                  onClick={() => this.setState({searchData: {}, newLeadData: {}, activeTab: "main"})}>Cancel</Button>
              </div>
            </Col>
          </Row>
        </TabPane>

        <TabPane tabId="addpage4">
          <Row>
            <Col xs="4">
              <Input type={"textarea"}
                     style={{marginRight: 10}}
                     multiple={true}
                     rows={7}
                     onChange={(evt) => {
                       this.props.setFileData({notes: evt.target.value})
                     }}
                     value={this.props.fileData.notes || ""}/>
            </Col>
            <Col xs="2">
              <div style={{display: "flex", flexDirection: "column", justifyContent: "space-around", fontSize: 11}}>
                <div>Add LMS Lead - Page 4 / 4</div>
                <div>
                  Marketing Folder:
                  <div>{this.state.newLeadData.folderPath || ""}</div>
                  <Button onClick={() => {
                    this.setState({showFolderSelection: true});
                  }}>Choose</Button>
                  {this.state.showFolderSelection && (
                    <LMSFolderSelection show={true}
                                        saveButton={"Choose..."}
                                        defaultFolder={this.state.newLeadData.fid || 0}
                                        copyOrMove={"move"}
                                        onSave={(fid, folderPath) => this.setState({
                                          newLeadData: {
                                            ...this.state.newLeadData,
                                            fid,
                                            folderPath
                                          },
                                          showFolderSelection: false
                                        })}
                                        onCancel={() => this.setState({showFolderSelection: false})}/>
                  )}
                </div>
              </div>
            </Col>
            <Col xs={2}>

            </Col>
            <Col xs={2}>
              <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
                fontSize: 11,
                height: "100%"
              }}>
                <div>&nbsp;</div>
                <div>
                  <Button onClick={() => {
                    this.setState({activeTab: "addpage3"});
                  }}>&lt; &lt; Prev</Button>
                  <Button color={"success"} onClick={() => {
                    this.addNewLMS();
                  }}>Submit</Button>
                </div>
                <Button
                  onClick={() => this.setState({searchData: {}, newLeadData: {}, activeTab: "main"})}>Cancel</Button>
              </div>
            </Col>
          </Row>
        </TabPane>

      </TabContent>
    </div>
  }

}


// WEBPACK FOOTER //
// ./src/containers/Briefcase/views/BriefcaseAddToLMS.js